import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'

@Component({
  selector: 'pcf-container',
  templateUrl: './pcf-container.component.html',
  styleUrls: ['./pcf-container.component.scss'],
})
export class PcfContainerComponent implements OnDestroy {
  @Output() pcfActionEmitter = new EventEmitter<boolean>()
  @ViewChild('pcfDialog') simpleDialogContent: TemplateRef<any>
  @Input() fundId: string
  @Input() asOfDate: string
  pcfAccepted = false

  //AEM content variables
  portfolioCompositionFileDisclaimer: AEMChunk
  portfolioAuthorizedDisclaimer: AEMChunk
  aemContentSub: Subscription

  /* eslint max-params: [2, 5] */
  constructor(
    private readonly viewContainer: ViewContainerRef,
    private readonly centralContentService: CentralContentService,
  ) {}

  ngOnInit() {
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
  }
  parseAEMContent(content) {
    this.portfolioCompositionFileDisclaimer =
      this.centralContentService.getContentByBody(
        'disclaimer_terms_and_conditions_portfolio_composition_file',
        content,
      )
    this.portfolioAuthorizedDisclaimer =
      this.centralContentService.getContentByBody(
        'disclaimer_portfolio_composition_file_authorized_participant',
        content,
      )
  }
  userAccepted(isAccepted: boolean) {
    //closeDialog
    if (isAccepted) {
      this.pcfAccepted = isAccepted
      this.pcfActionEmitter.emit(true)
    }
  }
  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
  }
}
